//'use strict';
export default class AppViewController {

    constructor($scope, $state) {

        let vm = this;
        vm.pageTitle = 'Getting Down To Earth';
        // $state.go('appView.contentSection', {section: "Bag Free, Hassle Free Travel"});

        $('#map-content').animate({opacity: 1}).delay(500).animate({opacity: .25, top: "0px"});
        $('#section-content').animate({opacity: 1}).delay(500).animate({opacity: .25, top: "0px"});

        $('#intro').animate({opacity: 0}).delay(300).animate({opacity: 1});

        vm.viewContent=()=>{

            $('#intro').animate({opacity: 0}, 300).slideUp(500);
            $('#map-content').animate({opacity: 1}, 500);
            $('#section-content').animate({opacity: 1}, 500);

        }

        $scope.$on('$locationChangeSuccess', function() {

            if($state.params.section === "Bag Free, Hassle Free Travel"){

                // $state.go('appView.contentSection', {section: $state.params.section});
            }

        })
    }
}
AppViewController.$inject = ['$scope', '$state'];


// WEBPACK FOOTER //
// ./src/app/app-view/app-view.controller.js